var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',{staticClass:"font-ubuntu h_menu"},[_c('div',{staticClass:"theme-cyan",attrs:{"id":"body"}},[(_vm.getEmail)?_c('header-view'):_vm._e(),_c('router-view')],1),_c('dev-test-modal'),_c('user-auth')],1)}
var staticRenderFns = []

export { render, staticRenderFns }